export default __webpack_public_path__ + "static/tools_ru-f2c167c30d4ac8b3581e7d65d36aca23.png";